export const getTabbedTableSX = (colors) => {
  return {
    "& .MuiDataGrid-columnHeaders": {
      borderBottom: "none",
      minHeight: "48px !important",
      maxHeight: "48px !important",
      "& .MuiDataGrid-columnHeaderTitle": {
        fontSize: "12px",
      },
    },
    "&.MuiDataGrid-root .MuiDataGrid-cell:focus-within": {
      outline: "none !important",
    },
    "& .MuiDataGrid-row": {
      cursor: "pointer",
      "& .MuiDataGrid-cell": {
        display: "flex",
        alignItems: "center",
        minHeight: "48px !important",
      },
    },
    "& .MuiDataGrid-virtualScroller": {
      "& .MuiDataGrid-virtualScrollerContent": {
        "& .MuiDataGrid-virtualScrollerRenderZone": {
          "& .MuiDataGrid-row": {
            height: "48px !important",
            minHeight: "48px !important",
            maxHeight: "48px !important",
          },
        },
      },
    },
    "& .MuiDataGrid-footerContainer": {
      borderTop: `1px solid ${colors.grey_20percent}`,
      "& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows, & .MuiTablePagination-select":
        {
          fontSize: "12px",
          fontWeight: "500",
        },
    },
  };
};
